import { c as _c } from "react/compiler-runtime";
import { type ReactElement } from 'react';
import { type GlobalLoaderProps } from './types';
import { StyledLinearProgressGlobalLoader } from './styles';
const GlobalLoader = t0 => {
  const $ = _c(8);
  let isLoading;
  let props;
  if ($[0] !== t0) {
    ({
      isLoading,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = isLoading;
    $[2] = props;
  } else {
    isLoading = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== isLoading || $[4] !== props) {
    t1 = isLoading && <StyledLinearProgressGlobalLoader {...props} />;
    $[3] = isLoading;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = <>{t1}</>;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default GlobalLoader;
export { GlobalLoader };